import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Cell } from 'src/app/models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditValueModalComponent } from './edit-value-modal/edit-value-modal.component';
import {
  CellManualEditMemoryModalComponent,
  CellManualEditMemoryModal } from './cell-manual-edit-memory-modal/cell-manual-edit-memory-modal.component';

/**
 * Component used for cell types cella_edit_con_memoria and cella_edit_manuale in the tables of subtool 4 of NLL
 */

@Component({
    selector: 'app-cell-manual-edit',
    templateUrl: './cell-manual-edit.component.html',
    styleUrls: ['./cell-manual-edit.component.scss'],
    standalone: false
})

export class CellManualEditComponent implements OnInit, OnChanges{

    @Input() data: Cell;
    @Input() withModal: boolean = true;
    @Input() memoryCells_permanent_memory?: boolean = false;
  @Output() sendSelectedCellValue: EventEmitter<Cell> = new EventEmitter();

  prevValue : string;
  constructor(private modalService: NgbModal) { }

  ngOnInit() { }

    ngOnChanges() {
        // questo serve a fare in modo che la cella rimanga flaggata come modificata (colore giallo) anche dopo il reload della pagina
        if (this.memoryCells_permanent_memory && this.data && this.data.value && this.data.value != this.data.original_value) this.data.is_edited = true;
        else this.data.is_edited = false;
    }
  /**
   * If the cell type is cella_edit_manuale, it opens the modal to edit the value in the cell
   * and sends the updated cell to the parent component
   */

  openCellManualEdit() {
    const modalRef = this.modalService.open(EditValueModalComponent, { centered: true, size: '50%' , backdrop: 'static'});
    modalRef.componentInstance.cellValue = this.data.value;
    modalRef.componentInstance.title = 'Define value manually';
    modalRef.componentInstance.inputLabel = 'Insert your value here';
    modalRef.componentInstance.closeModal.subscribe((newValue: string) => {
      this.data.is_edited = true;
      this.data.value = newValue;
      this.sendSelectedCellValue.emit(this.data);
    });
  }

  /**
   * If the cell type is cella_edit_con_memoria,
   * it opens the modal to subtract a number from the initial cell value
   * and sends the updated cell to the parent component
   */

  openCellManualEditWithMemory() {
    this.prevValue = this.data?.value;

    const modalRef = this.modalService.open(CellManualEditMemoryModalComponent, { centered: true, size: '50%', backdrop: 'static' });
    const subtractionValue = (this.data.original_value? parseFloat(this.data.original_value): 0) - parseFloat(this.data.value);
    modalRef.componentInstance.inputValues = {
      originalValue: this.data.original_value,
      modifyValue: subtractionValue <= 0 ? undefined : String(subtractionValue),
      newValue: this.data.value
    } as CellManualEditMemoryModal;
    modalRef.componentInstance.closeModal.subscribe((newValue: string) => {
      this.data.is_edited = true;
      this.data.value = newValue;
      this.data.obscure_cell = this.data.value !== newValue;
      this.sendSelectedCellValue.emit(this.data);
    });
    }


    saveValue() {
        this.prevValue = this.data.value;
    }

    processChange() {
        if (this.data.value !== this.prevValue) {
            this.data.is_edited = true;
            this.data.obscure_cell = true;
            ////console.log("this.data in cell-manual-edit: ", this.data);
            this.sendSelectedCellValue.emit(this.data);
        }
    }


}
